// 业务权限唯一入口。role=3 暂不重新定义，兼容原有非普通账号行为。
export function isAuthenticated(session) {
  return session.isLoggedIn === true && !!session.token
}

export function getPermissions(session) {
  const loggedIn = isAuthenticated(session)
  const role = String(session.role ?? '0')
  const viewType = String(session.viewType ?? '3')
  return {
    wind: loggedIn && viewType !== '2',
    solar: loggedIn && viewType !== '1',
    manage: loggedIn && role !== '1',
    queryMap: loggedIn,
    queryOutsideStation: loggedIn && role !== '1'
  }
}

export function getHomePath(session) {
  return String(session.viewType) === '2' ? '/solar' : '/wind'
}

// 返回 null 表示允许访问；父级路由的要求同样生效。
export function getRouteRedirect(to, session) {
  const records = to.matched || []
  const protectedRoute = records.some(({ meta }) => meta && (meta.requiresAuth || meta.permission))
  if (protectedRoute && !isAuthenticated(session)) {
    return { path: '/login', query: { redirect: to.fullPath || to.path } }
  }
  if (to.path === '/login' && isAuthenticated(session)) return getHomePath(session)
  const permissions = getPermissions(session)
  if (records.some(({ meta }) => meta && meta.permission && permissions[meta.permission] !== true)) {
    return getHomePath(session)
  }
  return null
}
